import { render, staticRenderFns } from "./SidemenuHeader.vue?vue&type=template&id=30e2d122&scoped=true&"
import script from "./SidemenuHeader.vue?vue&type=script&lang=ts&"
export * from "./SidemenuHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SidemenuHeader.vue?vue&type=style&index=0&id=30e2d122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e2d122",
  null
  
)

export default component.exports